import apiClient from "../vue/http/axios"

async function signIn(data, headers) {
  return await apiClient.post('users/sign_in', {
    data
  }, {
    headers,
  });
}

export default {
  signIn,
}